import { BrowserRouter } from "react-router-dom"
import { AppRouter } from "./router"
import { Header } from "@/shared/components/layout/Header"
import { Footer } from "@/shared/components/layout/Footer"
import { WhatsAppFloat } from "@/shared/components/common/WhatsAppFloat"
import { ScrollToTop } from "@/shared/components/ScrollToTop"



function App() {
  return (
    <BrowserRouter>
    <ScrollToTop /> 
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1">
          <AppRouter />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </BrowserRouter>
  )
}


export default App
